import { Navigate, Route, Routes } from 'react-router';
import { AppShell } from '@/components/AppShell';
import RequireRole from '@/components/RequireRole';
import { ToastProvider } from '@/components/Toast';
import { AuthProvider } from '@/lib/auth';
import AssessPage from '@/features/assess/AssessPage';
import PipelinePage from '@/features/pipeline/PipelinePage';
import LeadPage from '@/features/leads/LeadPage';
import NotificationsSettingsPage from '@/features/settings/NotificationsSettingsPage';
import ScreeningSettingsPage from '@/features/screening/ScreeningSettingsPage';
import StagesSettingsPage from '@/features/stages/StagesSettingsPage';

/**
 * Everything behind the Innu token. `AuthProvider` redirects to the Shell
 * when there is no session, so it must never wrap a public route.
 */
function AuthenticatedApp() {
  return (
    <AuthProvider>
      <ToastProvider>
        <AppShell>
          <Routes>
            <Route path="/" element={<Navigate to="/pipeline" replace />} />
            <Route path="/pipeline" element={<PipelinePage />} />
            <Route path="/leads/:id" element={<LeadPage />} />
            {/* Guarded on the ROUTE, not just the sidebar — a hidden link still
                leaves the URL reachable. The worker enforces it too. */}
            <Route
              path="/settings/stages"
              element={
                <RequireRole role="company_admin">
                  <StagesSettingsPage />
                </RequireRole>
              }
            />
            <Route
              path="/settings/notifications"
              element={
                <RequireRole role="company_admin">
                  <NotificationsSettingsPage />
                </RequireRole>
              }
            />
            <Route
              path="/settings/screening"
              element={
                <RequireRole role="company_admin">
                  <ScreeningSettingsPage />
                </RequireRole>
              }
            />
            <Route path="*" element={<Navigate to="/pipeline" replace />} />
          </Routes>
        </AppShell>
      </ToastProvider>
    </AuthProvider>
  );
}

export default function App() {
  return (
    <Routes>
      {/* Public: the candidate's assessment link, opened from a text on a phone. */}
      <Route path="/assess/:token" element={<AssessPage />} />
      <Route path="/*" element={<AuthenticatedApp />} />
    </Routes>
  );
}
